<style lang="less" scoped>
.table {
  height: 100%;
  width: 100%;
}
</style>
<template>
  <div>
    <v-btn @click="show_form = true">
      新增
    </v-btn>
    <v-simple-table class="table mt-5">
      <thead>
        <th width="15%">
          标题
        </th>
        <th width="20%">
          内容
        </th>
        <th width="20%">
          url
        </th>
        <th width="15%">
          发送时间
        </th>
        <th width="8%">
          发送账号
        </th>
        <th width="8%">
          状态
        </th>
        <!-- <th width="5%">
          操作
        </th> -->
      </thead>
      <tbody class="text-center">
        <tr
          v-for="record in message_records"
          :key="record.id"
        >
          <td>{{ record.title }}</td>
          <td>{{ record.content }}</td>
          <td>{{ record.url }}</td>
          <td class="text-right">
            <v-chip
              v-if="record.send_at"
              small
              color="green"
              label
              outlined
            >
              定时
            </v-chip>
            {{ record.send_at ? formatTime(record.send_at) : formatTime(record.created_at) }}
          </td>
          <td>{{ accountName(record.wechat_account) }}</td>
          <td
            :class="messageStatusClass(record)"
            v-text="messageStatusText(record)"
          />
          <!-- <td /> -->
        </tr>
      </tbody>
    </v-simple-table>
    <div
      v-if="page_params.total"
      class="line paginate-fix-bottom py-0"
    >
      <Pagination
        :total="page_params.total"
        :page-size="page_params.per_page"
        :current="page_params.page"
        :size-arr="[10, 20, 50]"
        @pageChange="pageChange"
        @changePageSize="changePageSize"
      />
    </div>
    <Modal
      v-model="show_form"
      dynamic-height
      :height-rate="0.8"
      width="600px"
      title="发送消息"
      ok-text="发送"
      persistent
      @ok="sendMessage"
      @cancel="resetForm"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-radio-group
          v-model="message.wechat_account"
          row
        >
          <template v-slot:label>
            <div>发送账号</div>
          </template>
          <v-radio
            v-for="(v, k) in wechat_accounts"
            :key="k"
            :label="v"
            :value="k"
          />
        </v-radio-group>
        
        <DatetimePicker
          v-model="message.send_at"
          label="定时发送"
          clear-text="清空"
          ok-text="确定"
          :date-picker-props="dateProps"
          :time-picker-props="timeProps"
        >
          <template slot="dateIcon">
            <v-icon>mdi-calendar</v-icon>
          </template>
          <template slot="timeIcon">
            <v-icon>mdi-clock-outline</v-icon>
          </template>
        </DatetimePicker>

        <v-text-field
          v-model="message.title"
          :rules="[
            $rule.notEmpty('标题'),
            $rule.length({max: 30})
          ]"
          :counter="30"
          label="消息标题"
          required
          clearable
        />

        <v-textarea
          v-model="message.content"
          :rules="[
            $rule.notEmpty('消息内容'),
            $rule.length({max: 1000})
          ]"
          :counter="1000"
          label="消息内容"
          rows="3"
          auto-grow
          required
          clearable
        />

        <v-text-field
          v-model="message.url"
          label="链接地址"
          required
        />
        <div>
          <v-autocomplete
            v-model="search_person"
            :items="proxy_search_list"
            label="收件人（组）"
            item-text="info"
            item-value="id"
            return-object
            :loading="search_person_loading"
            @update:search-input="searchPersonProxy"
            @change="selectPerson"
          />
          <!-- <CustomerSelector
            outlined
            label="收件人"
            @change="addCustomer"
          /> -->
          <v-chip
            v-for="(customer, idx) in message.customers"
            :key="customer.id"
            class="ma-2"
            close
            @click:close="removeCustomer(idx)"
          >
            {{ customer.account }}
          </v-chip>
          <span v-if="!checkUser()">请选择收件人</span>
        </div>
      </v-form>
    </Modal>
  </div>
</template>
<script route="/notice/send">
  // import CustomerSelector from "../components/customer/v-selector";
  // import Modal from "../../vuetify_custom/v-modal";
  import Pagination from "../../vuetify_custom/v-pagination";
  import Util from "../../libs/util";
  import Modal from '@/vuetify_custom/v-modal_v1'
  import DatetimePicker from './DatetimePicker'
  const { group_send_add, group_send_list } = Util.api || {};
  const { formatTime } = Util;
  import { throttle } from '@/libs/functions_utils'
  export default {
    components: {
      Modal,
      // CustomerSelector,
      Pagination,
      DatetimePicker
    },
    data() {
      return {
        search_person_loading: false,
        valid: false,
        show_form: false,
        dateProps: {
          noTitle: true,
          scrollable: true,
          reactive: true,
          locale: "zh-cn"
        },
        timeProps: {
          format: '24hr'
        },
        message: {
          title: "",
          content: "",
          url: "",
          send_at: null,
          wechat_account: "mis",
          customers: [],
        },
        page_params: {
          page: 1,
          per_page: 10,
          total: 0,
        },
        message_records: [],
        wechat_accounts: {
          mis: "MIS",
          finance_report: "财务报告"
        },
        search_person: '',
        search_person_list: [],
        search_person_list_hash: {},
        groups_list: []
      };
    },
    computed: {
      customers_hash() {
        return (this.message.customers || []).reduce((t, i) => {
          t[i.id] = true
          return t
        }, {})
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      proxy_search_list() {
        return this.groups_list.concat(this.search_person_list)
      }
    },
    created() {
    //
    },
    mounted() {
      this.getList();
      this.getGroup()
    },
    methods: {
      getGroup() {
        this.$util.http.get(this.$util.api.route_group_all)
          .then((data) => {
            const groups = data.groups || []
            this.groups_list = groups.filter(i => !i.del).map(item => {
              return {
                ...item,
                id: `_${item.id}`,
                info: `${item.group_key}-${item.name}`
              }
            })
          })
      },
      selectPerson(item) {
        this.$nextTick(() => {
          this.search_person = null
        })
        // 群组
        if (item.group_key) {
          this.$util.http.get(this.$util.api.route_group_customers, {id:item.id.slice(1)})
            .then((data) => {
              const group = data.group && data.group.customers || []
              group.forEach(i => {
                this.addCustomer(i)
              });
            })
        } else { // 个人
          this.addCustomer(item)
        }
      },
      getPerson(e) {
        if (!this.throttle_ac) {
          this.throttle_ac = throttle.call(this, function(e) {
            this.search_person_loading = true
            this.$util.http.get(this.$util.api.customer_select_search, {search: e})
              .then((data) => {
                if (!data.customers || !data.customers.length) {
                  return 
                }
                const new_search_person_list = data.customers.map(item => {
                  return {
                    ...item,
                    info: `${item.account}-${item.team_name}`
                  }
                }).filter(i => !this.search_person_list_hash[i.id])
                if (new_search_person_list.length) {
                  this.search_person_list = this.search_person_list.concat(new_search_person_list)
                  new_search_person_list.forEach(i => {
                    this.search_person_list_hash[i.id] = i
                  })
                }
              }).finally(() => {
                this.search_person_loading = false
              });
          }, 500)
        }
        if (!this.groups_list.length) {
          this.getGroup()
        }
        this.throttle_ac(e)
      },
      searchPersonProxy(e) {
        this.getPerson(e)
      },
      messageStatusClass(item) {
        return {
          "error--text": item.status == "failed",
          "success--text": item.status == "success",
          "accent--text": item.status == null,
        };
      },
      messageStatusText(item) {
        if (item.status == null) {
          return "未知";
        } else {
          return "发送" + (item.status == "success" ? "成功" : "失败");
        }
      },
      accountName(account) {
        return this.wechat_accounts[account] || '未知'
      },
      addCustomer(customer) {
        if (this.customers_hash[customer.id]) {
          return 
        }
        this.message.customers.push(customer);
      },
      removeCustomer(idx) {
        this.message.customers.splice(idx, 1);
      },
      pageChange(page) {
        this.getList({
          ...this.params,
          page,
        });
      },
      changePageSize(pageSize) {
        this.getList({
          ...this.params,
          per_page: pageSize,
          page: 1,
        });
      },
      checkForm() {
        const form = this.$refs.form;
        form.validate();
        return this.valid && this.checkUser();
      },
      checkUser() {
        return this.message.customers.length != 0;
      },
      getList(_params) {
        const { total, ...other } = _params || this.page_params;
        this.$http.get(group_send_list, other).then((data) => {
          this.message_records = data.messages;
          const p = this.page_params;
          ({
            cur_page: p.page,
            per_page: p.per_page,
            total_count: p.total,
          } = data);
        });
      },
      sendMessage() {
        if (!this.checkForm()) {
          return;
        }
        const params = this.message;
        params["customer_ids"] = this.message.customers.map((c) => c.id);
        this.$http
          .post(group_send_add, params)
          .then((data) => {
            setTimeout(() => {
              this.getList();
            }, 500);
          })
          .catch((e) => {
            this.$Message.error(e);
          })
          .finally(() => {
            this.show_form = false;
            this.resetForm()
          });
      },
      resetForm() {
        this.$refs.form.reset()
        this.$nextTick(() => {this.message = this.$options.data().message})
      },
      formatTime,
    },
  };
</script>
